import { render, staticRenderFns } from "./FloatingChatButton.vue?vue&type=template&id=eed91b78&scoped=true&"
import script from "./FloatingChatButton.vue?vue&type=script&lang=js&"
export * from "./FloatingChatButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChatButton.vue?vue&type=style&index=0&id=eed91b78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed91b78",
  null
  
)

export default component.exports